import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line import/no-cycle
import { useFetch } from '../../../services/transports';
import { languages } from '../../../constants';
import { LabeledSelect } from '..';
import { searchLabelLevelTypes } from '../../../api/systemManagement';

export const SearchLabelLevelTypesDropdown = ({ label, id, onChange, withAsterisks, disabled, value }) => {
  const { i18n, t } = useTranslation();

  const [ options, setOptions ] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [ { data }, fetchSearchLabelLevelTypesDropdown ] = useFetch(
    searchLabelLevelTypes,
    (response => {
      const container = response?.data;
      if (container) {
        setOptions(
          container.map(i => ({
            value: i.type,
            text: i18n.language === languages.EN ? `${i.nameEn}` : `${i.nameAr}`,
            item: i
          }))
        );
      }
    })
  );

  useEffect(() => {
    fetchSearchLabelLevelTypesDropdown();
  }, []);

  return (
    <LabeledSelect
      data-testid={ `${id}-types` }
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      searchDelay={ 250 }
      options={ options }
      filterOption={ false }
      withDebounceSearch={ true }
      EmptyComponent={ t('ERR.noMatched') }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      allowClear
      value={ value }
      placeholder={ t('fields.choose') }
      setValueAsObject={ false }
    />
  );
};
